import React, { useEffect, useState } from "react";
import "./ThemeChanger.scss";
import { BsSunFill } from "react-icons/bs";
import { HiMoon } from "react-icons/hi";
import { themeChanger } from "../../utils/services/theme";
import store from "../../store/store";
import { Tooltip } from "react-tooltip";
import { RootState } from "../../store/types";

const ThemeChanger: React.FC = () => {
  const [currentTheme, changeTheme] = useState<string>("light");
  useEffect(() => {
    const currentStore = store?.getState() as RootState;
    setTheme(currentStore?.otherData?.["theme"] || currentTheme);
  }, []);

  const setTheme = (theme: string) => {
    changeTheme(theme);
    themeChanger(theme);
  };

  return (
    <div className="ThemeChanger">
      {currentTheme === "light" && (
        <span
          className="ThemeChanger__icon"
          onClick={() => setTheme("dark")}
          data-tooltip-id="theme-tooltip"
          data-tooltip-content="Dark Theme"
        >
          <HiMoon />
        </span>
      )}
      {currentTheme === "dark" && (
        <span
          className="ThemeChanger__icon"
          onClick={() => setTheme("light")}
          data-tooltip-id="theme-tooltip"
          data-tooltip-content="Light Theme"
        >
          <BsSunFill />
        </span>
      )}
      <Tooltip id="theme-tooltip" />
    </div>
  );
};

export default ThemeChanger;
